import { render, staticRenderFns } from "./PlanningPatternDetail.vue?vue&type=template&id=2d0586af&scoped=true&"
import script from "./PlanningPatternDetail.vue?vue&type=script&lang=js&"
export * from "./PlanningPatternDetail.vue?vue&type=script&lang=js&"
import style0 from "./PlanningPatternDetail.vue?vue&type=style&index=0&id=2d0586af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0586af",
  null
  
)

export default component.exports